export default {"src":"/_next/static/media/step3b.25ff7c83.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};